var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsIsolation = function SvgDlsIsolation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.15 6.975a1.8 1.8 0 10.001-3.6 1.8 1.8 0 00-.001 3.6M13.5 8h-2.7C9.81 8 9 8.81 9 9.8v4.95h1.35v6.75h3.6v-6.75h1.35V9.8c0-.99-.81-1.8-1.8-1.8",
    fill: "var(--color-alert)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z",
    stroke: "var(--color-alert)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1,2"
  }))));
};

export default __webpack_public_path__ + "static/media/DLS_Isolation.973fd6b1.svg";
export { SvgDlsIsolation as ReactComponent };